import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Input, Checkbox, Button, List, message } from "antd";
import { HEAD_DEFAULT, MyIcon } from "../../common/baseConfig";
import * as actions from './redux/actions';
import NoneData from "../common/NoneData";
import moment from "moment";
export class CourseComment extends Component {
  state = {
    commentTxt: "",
    isAnonymity: false,
    loadMore: false,
  }
  static propTypes = {
    course: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  onThumbUp(ID) {
    const { CourseID } = this.props;
    //评论点赞 或者取消点赞
    this.props.actions.fetchUpdateThumpUp({ Comment_ID: ID }).then(() => {
      //重新拉取评论列表更新点赞
      this.props.actions.fetchGetCourseComment({ Course_ID: CourseID, Valid: 1 });
    })
  }
  onCheckAnonymity(e) {
    this.setState({
      isAnonymity: e.target.checked,
    })
  }
  onComment(e) {
    if (e.target.value.length > 300) return;
    this.setState({
      commentTxt: e.target.value,
    })
  }
  onCommentSubmit() {
    const { CourseID } = this.props;
    const { commentTxt, isAnonymity } = this.state;

    if (this.state.commentTxt.trim() === "") {
      message.warning("评价内容不能为空");
      return;
    }
    //评论课程
    this.props.actions.fetchAddComment({
      Course_ID: CourseID,
      Content: commentTxt,
      Anonymity: isAnonymity ? 1 : 0,
    }).then(() => {
      //评论成功后更新数据
      message.success('评价成功');
      this.props.actions.fetchGetCourseComment({ Course_ID: CourseID, Valid: 1 });
    })
    this.setState({
      commentTxt: "",
    })
  }
  render() {
    const { fetchGetCourseCommentSuccess, fetchGetCourseCommentCount } = this.props.course;
    const { loadMore, commentTxt } = this.state;
    if (!fetchGetCourseCommentSuccess) return null;
    let Data = fetchGetCourseCommentSuccess.slice(0, 4);
    if (loadMore) {
      Data = fetchGetCourseCommentSuccess;
    }
    return (
      <div className="course-course-comment">
        <div className="inner">
          <div className="Buy-commentView">
            <div className="inputView">
              <Input.TextArea onChange={this.onComment.bind(this)} placeholder="快来发表您的评价" value={commentTxt}></Input.TextArea>
              <span>{this.state.commentTxt.length}/300</span>
            </div>
            <div className="inputBtn">
              <Checkbox onChange={this.onCheckAnonymity.bind(this)}><span className={"anonymity"}>匿名评价</span></Checkbox>
              <Button type="theme" onClick={this.onCommentSubmit.bind(this)}>评价</Button>
            </div>
          </div>
          <div className="line"></div>
          {Data && Data.length > 0 && <h1>全部评价<span>{fetchGetCourseCommentCount}</span></h1>}
          {Data && Data.length > 0 ? <List
            itemLayout="horizontal"
            dataSource={Data}
            footer={Data.length > 0 && <div className="footer">
              {
                loadMore ? <p>没有更多评价了</p> : <p className="more" onClick={() => this.setState({
                  loadMore: true,
                })}>查看更多评价</p>
              }
            </div>}
            renderItem={item => (<div key={item.ID} className="comment-item">
              {
                item.Anonymity === 1 ? <img src={HEAD_DEFAULT} alt="" /> : <img src={item.HeadImg || HEAD_DEFAULT} alt="" />
              }
              <div className="comment-item-content">
                <h2>
                  <span>{item.Anonymity === 1 ? "匿名" : item.StudentName}</span>
                  <span>{moment(new Date(item.AddTime)).format('YYYY-MM-DD HH:mm:ss')}</span>
                </h2>
                <div className="comment-content-txt">
                  {item.Content}
                </div>
                <div className="comment-thumb-up">
                  {
                    item.MyThumbUp === 1 ? <p className="active" onClick={this.onThumbUp.bind(this, item.ID)}><MyIcon type="icondianzan" /><span>{item.ThumbUp}</span></p> : <p onClick={this.onThumbUp.bind(this, item.ID)}><MyIcon type="icondianzan1" /><span>{item.ThumbUp}</span></p>
                  }
                </div>
              </div>
            </div>)}
          >
          </List> : <div className="noneData">
              <NoneData type={2} />
            </div>}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CourseComment);



// WEBPACK FOOTER //
// ./src/features/course/CourseComment.js